import { render } from "./TherapyView.vue?vue&type=template&id=0916e40e&scoped=true"
import script from "./TherapyView.vue?vue&type=script&lang=js"
export * from "./TherapyView.vue?vue&type=script&lang=js"

import "./TherapyView.vue?vue&type=style&index=0&id=0916e40e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0916e40e"]])

export default __exports__